{
	"deleteDescription": "L'invité sera définitivement supprimé. Voulez-vous quand même continuer ?",
	"deleteGuest": "Supprimer l'invité",
	"emptyText": "Aucune donnée à afficher.",
	"excludeGuest": "Supprimer l'invité",
	"reports": {
		"goTo": "aller à",
		"cashierAdjustmentsReport": {
			"adjustmentTypes": {
				"bleeding": "Retrait de caisse",
				"pettyCash": "Petite monnaie"
			},
			"cashierAdjustmentForm": {
				"errors": {
					"emptyValue": "Taper un montant"
				},
				"inputLabels": {
					"obs": "Observation",
					"value": "Montant"
				}
			},
			"cashierAdjustmentModal": {
				"title": "Ajouter {{adjustmentType}}",
				"notAllowedText": "Cette action ne peut pas être effectuée lorsque l'événement est déjà terminé."
			},
			"excelFileName": "ajustements-caisse-{{timestamp}}",
			"filters": {
				"byAuthor": {
					"label": "Filtrer par Employé",
					"placeholder": "Sélectionner un employé"
				},
				"byCashier": {
					"label": "Filtrer par Caisse",
					"placeholder": "Sélectionner une caisse"
				},
				"byType": {
					"label": "Filtrer par Type",
					"placeholder": "Sélectionner un type"
				}
			},
			"successfullExportMsg": "Tableau exporté avec succès !",
			"table": {
				"columns": {
					"author": "Employé",
					"cashier": "Caisse",
					"obs": "Commentaires",
					"timestamp": "Date/Heure",
					"type": "Type",
					"value": "Montant"
				}
			},
			"title": "Retrait de caisse et petit monnaie",
			"exchangeTotal": "Total en fonds de change",
			"cashWithdrawal": "Total en retrait de caisse"
		},
		"clientsReportTable": {
			"appTransactionsValue": "Payé avec app",
			"bonusTransactionsValue": "Payé avec bonus",
			"cpf": "CPF",
			"customerConsumption": "Consommation par client",
			"editData": "Modifier les données",
			"empty": "Aucune donnée à afficher.",
			"filename": "consommation-par-client",
			"hasApp": "a l'app",
			"housePostPaidTransactionsValue": "Post payé dans le lieu",
			"housePrePaidTransactionsValue": "Paiement direct dans le lieu",
			"invoices": "Factures",
			"name": "Nom",
			"noApp": "N'a pas d'app",
			"phone": "Téléhone",
			"searchClient": "Rechercher un client ici",
			"seeExtract": "Voir extract",
			"title": "Consommation par client",
			"total": "Total",
			"zigCode": "Code ZIG"
		},
		"cmvReportTable": {
			"mountableCaps": "COMBINABLE",
			"mountable": "Produit combinable",
			"name": "Nom",
			"section": "Section",
			"count": "Quantité",
			"productUnitCost": "Prix unitaire",
			"total": "Total Prix"
		},
		"rappiDiscount": {
			"date": "Date",
			"employee": "Employé ayant appliqué la réduction",
			"emptyText": "Aucune donnée à afficher.",
			"products": "Produits",
			"value": "Montant réduction"
		},
		"reserveReportTable": {
			"confirmedPeople": "{{value}} clients confirmés",
			"confirmedPeopleExcel": "Confirmé",
			"count": "Qté.",
			"date": "Date du forfait",
			"discount": "Réduction",
			"discountTooltip": "Les remises éventuelles sur le compte font partie de ce montant.",
			"downloadTable": "Télécharger Table",
			"filenameExcel": "forfaits",
			"filenameExcelDetails": "détails_forfait_",
			"invitedPeople": "Invités",
			"issued": "Émission de factures",
			"issuedInvoices": "Émission de factures",
			"name": "Nom",
			"noPromotion": "Produits hors promotion",
			"packageName": "Nom du forfait",
			"productName": "Total",
			"productNameExcel": "Produit",
			"products": "Produits",
			"promotionName": "Promotion",
			"receivedValue": "Montant reçu",
			"reserveValue": "facturé en valeur de forfaits",
			"revenue": "Facturation",
			"selledCount": "Quantité",
			"ticketTooltip": "Ticket moyen du forfait Clients",
			"tips": "pourboires",
			"title": "Détails du Forfait",
			"titleExcel": "forfaits",
			"titleExcelDetails": "Détails du forfait",
			"total": "Total facturé",
			"totalProductsValue": "facturé sur les produits",
			"totalValue": "Total Montant",
			"unitValue": "Unitary montant",
			"value": "Montant Vrac"
		},
		"stockReportTable": {
			"bar": "Bar",
			"category": "Transféré du {{product}}",
			"employeeBar": "Employé deBar",
			"quantity": "Quantité",
			"stocker": "Stocker",
			"time": "Time",
			"title": "Transferts de stock"
		}
	}
}
